import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { VslSection } from "./components/VslSection";
import { EditorialMarquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Services } from "./components/Services";
import { CtaSection } from "./components/CtaSection";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        const raf = (time) => {
            lenis.raf(time);
            requestAnimationFrame(raf);
        };
        const id = requestAnimationFrame(raf);

        const onAnchor = (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;
            const target = document.querySelector(link.getAttribute("href"));
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -70 });
            }
        };
        document.addEventListener("click", onAnchor);
        return () => {
            cancelAnimationFrame(id);
            lenis.destroy();
            document.removeEventListener("click", onAnchor);
        };
    }, []);

    return (
        <div className="App bg-cream text-navy">
            <div className="grain-overlay" aria-hidden="true" />
            <Header />
            <main>
                <Hero />
                <VslSection />
                <EditorialMarquee />
                <Manifesto />
                <Services />
                <CtaSection />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}

export default App;
